import React from "react"
import styles from "./RemovableListItem.module.scss"
import { faTimes } from "@fortawesome/pro-light-svg-icons/faTimes"
import IconButton from "../../IconButton/IconButton"
import TooltipTrigger from "../../TooltipTrigger/TooltipTrigger"
import { isString } from "../../../utility/common/isString"
import { testId as commonTestIds } from "../../../utility/tests/testId/common"

export interface RemovableListItemProps {
    onDelete: () => void
    disabled?: boolean
    testId?: string
}

const MAX_SHOW_CHILDREN_LENGTH = 81

const RemovableListItem: React.FC<RemovableListItemProps> = props => {
    const { children, onDelete, disabled, testId = "" } = props
    const tooltipContent = isString(children) ? children : ""

    return (
        <div className={styles.removableListItem}>
            <TooltipTrigger
                id={`item-${children}`}
                content={tooltipContent}
                condition={tooltipContent.length > MAX_SHOW_CHILDREN_LENGTH}
            >
                <span
                    className={styles.removableListItem__title}
                    data-testid={testId ? `${testId}-remove-item-title` : commonTestIds.removableListItemTitle}
                >
                    {children}
                </span>
            </TooltipTrigger>

            {!disabled && (
                <IconButton
                    icon={faTimes}
                    variant="link"
                    className={styles.removableListItem__deleteIcon}
                    onClick={onDelete}
                    testId={testId ? `${testId}-remove-item-button` : commonTestIds.removableListItem}
                />
            )}
        </div>
    )
}

export default RemovableListItem
